import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { getUsePrimaryUrlParams } from "../../utils/utils";
import { ISchema } from "clients/LaForgeClient/validation-types/SchemaDefinition";

export const testCustomerAccountUpdatedWebhook = (axios: IAxiosInstance) => {
  return async ({
    customerAccountUpdatedWebhook,
    userType,
    test,
    usePrimary,
  }: ISchema["#/definitions/ITestCustomerAccountUpdatedWebhookArgs"]) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/ITestCustomerAccountUpdatedWebhookResponse"]
    >(
      `/api/testCustomerAccountUpdatedWebhook${getUsePrimaryUrlParams(
        usePrimary
      )}`,
      {
        customer_account_update_webhook: customerAccountUpdatedWebhook,
        user_type: userType,
        test,
      }
    );

    const { data: responseData } = response;
    if (!responseData.success) {
      throw new Error(`Something went wrong`);
    }
    return responseData;
  };
};
